import React from "react";
import { MdOutlineNoPhotography } from "react-icons/md";

interface ICellImage {
  src: string;
}

const CellImage: React.FC<ICellImage> = (props) => {
  const { src } = props;

  return (
    <div>
      {src ? (
        <img
          src={`${process.env.REACT_APP_PUBLIC_URL}/${src}`}
          alt="courier"
          className="h-5 w-full rounded-sm object-contain"
        />
      ) : (
        <div className="flex items-center gap-2">
          <MdOutlineNoPhotography className="text-base text-brand-500 opacity-60" />
          <span className="text-sm font-semibold text-gray-500">No Image</span>
        </div>
      )}
    </div>
  );
};

export default CellImage;
